// Order
export const PLACE_ORDER = 'checkout/PLACE_ORDER';
export const RECEIVE_ORDER = 'checkout/RECEIVE_ORDER';
export const SET_ORDER_ERROR = 'checkout/SET_ORDER_ERROR';
export const REMOVE_ORDER_ERROR = 'checkout/REMOVE_ORDER_ERROR';

export const RESET_PAYMENT_DETAILS = 'checkout/RESET_PAYMENT_DETAILS';
export const SET_IS_PAYMENT_IN_PROCESS = 'checkout/SET_IS_PAYMENT_IN_PROCESS';

// Address
export const RECEIVE_ADDRESS_FORM = 'checkout/RECEIVE_ADDRESS_FORM';
export const UPDATE_ADDRESS_FORM = 'checkout/UPDATE_ADDRESS_FORM';
export const UPDATE_ADDRESS_MATCH_FIELD = 'checkout/UPDATE_ADDRESS_MATCH_FIELD';
export const SET_IS_EDITING_ADDRESS_FORM = 'checkout/SET_IS_EDITING_ADDRESS_FORM';
export const SET_ADDRESS_ERROR = 'checkout/SET_ADDRESS_ERROR';
export const REMOVE_ADDRESS_ERROR = 'checkout/REMOVE_ADDRESS_ERROR';
export const REMOVE_ADDRESS_FORM_VALIDATION_ERROR = 'checkout/REMOVE_ADDRESS_FORM_VALIDATION_ERROR';

// Voucher
export const SET_VOUCHER_CODE_ERROR = 'checkout/SET_VOUCHER_CODE_ERROR';
export const REMOVE_VOUCHER_CODE_ERROR = 'checkout/REMOVE_VOUCHER_CODE_ERROR';

// Gift card
export const SET_GIFT_CARD_CODE_ERROR = 'checkout/SET_GIFT_CARD_CODE_ERROR';
export const REMOVE_GIFT_CARD_CODE_ERROR = 'checkout/REMOVE_GIFT_CARD_CODE_ERROR';

// Shipping
export const RECEIVE_SHIPPING_LIST_DATA = 'checkout/RECEIVE_SHIPPING_LIST_DATA';
export const RESET_SHIPPING_LIST_DATA = 'checkout/RESET_SHIPPING_LIST_DATA';
export const SET_SHIPPING_ERROR = 'checkout/SET_SHIPPING_ERROR';
export const REMOVE_SHIPPING_ERROR = 'checkout/REMOVE_SHIPPING_ERROR';

// Payments
export const RECEIVE_PAYMENT_LIST_DATA = 'checkout/RECEIVE_PAYMENT_LIST_DATA';
export const RESET_PAYMENT_LIST_DATA = 'checkout/RESET_PAYMENT_LIST_DATA';

export const SET_PAYMENTS_ERROR = 'checkout/SET_PAYMENTS_ERROR';
export const REMOVE_PAYMENTS_ERROR = 'checkout/REMOVE_PAYMENTS_ERROR';

// Newsletter
export const RECEIVE_NEWSLETTER = 'checkout/RECEIVE_NEWSLETTER';
export const TOGGLE_NEWSLETTER_SUBSCRIPTION = 'checkout/TOGGLE_NEWSLETTER_SUBSCRIPTION';
export const TOGGLE_CLUB_SIGNUP = 'checkout/TOGGLE_CLUB_SIGNUP';
export const SET_NEWSLETTER_SUBSCRIPTION_GENDER = 'checkout/SET_NEWSLETTER_SUBSCRIPTION_GENDER';
export const SET_NEWSLETTER_SUBSCRIPTION_KIDS_PREFERENCE = 'checkout/SET_NEWSLETTER_SUBSCRIPTION_KIDS_PREFERENCE';
export const TOGGLE_CROSS_NEWSLETTER_SUBSCRIPTION = 'checkout/TOGGLE_CROSS_NEWSLETTER_SUBSCRIPTION';
export const TOGGLE_SOFT_OPT_IN_NEWSLETTER_SUBSCRIPTION = 'checkout/TOGGLE_SOFT_OPT_IN_NEWSLETTER_SUBSCRIPTION';

// Terms and conditions
export const SET_HAS_ACCEPTED_TERMS_AND_CONDITIONS = 'checkout/SET_HAS_ACCEPTED_TERMS_AND_CONDITIONS';
export const SET_HAS_TERMS_AND_CONDITIONS_ERROR = 'checkout/SET_HAS_TERMS_AND_CONDITIONS_ERROR';

// Tracking
export const SET_DIRTY_STEP = 'checkout/SET_DIRTY_STEP';

// Config
export const SET_CONFIG = 'checkout/SET_CONFIG';

// Transaction
export const SET_IS_PROCESSING_TRANSACTION = 'checkout/SET_IS_PROCESSING_TRANSACTION';

export const SET_TRANSACTION_PAYMENT_DATA = 'checkout/SET_TRANSACTION_PAYMENT_DATA';
export const RESET_TRANSACTION = 'checkout/RESET_TRANSACTION';
export const REMOVE_TRANSACTION_ERROR = 'checkout/REMOVE_TRANSACTION_ERROR';
// Checkout global
export const SET_IS_REQUEST_PENDING = 'checkout/SET_IS_REQUEST_PENDING';
export const SET_CHECKOUT_ERROR = 'checkout/SET_CHECKOUT_ERROR';
